<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane
      v-for="(v,i) in tabData"
      :key="i"
      :label="v.label" 
      :name="v.name">
      <slot></slot>
      </el-tab-pane>
  </el-tabs>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
export default {
  name:'tabBox',
  props:{
    tabData:{
      type: Array,
      default(){
        return [];
      }
    },
    value:{
      type:[String , Array]
    }
  },
  data(){
    return {

    }
  },
  methods:{
    handleClick(v){
      this.$emit('click',v)
    }
  },
  computed:{
    activeName:{
      get(){
        return this.value;
      },
      set(v){
        this.$emit('input',v)
      },
    }
  },
  components:{
    elTabs: Tabs,
    elTabPane: TabPane
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/tabBox.vue